/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiTestHealthGet$Params {}

export function apiTestHealthGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiTestHealthGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<{}>> {
    const rb = new RequestBuilder(rootUrl, apiTestHealthGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<{}>;
        }),
    );
}

apiTestHealthGet.PATH = '/api/test/health';
